<template>
    <list-group :item="item" v-bind:sub-group="true"/>
</template>

<script>

    export default {
        name: 'ListSubGroup',
        components: {
            ListGroup: () => import('./Group'),
        },
        props: {
            item: {
                type: Object,
                default: () => ({
                    text: '',
                    icon: false,
                }),
            },
        },
    };
</script>
